module.exports = __webpack_public_path__ + "static/media/post_box.36bb3df4.svg";